import { render, staticRenderFns } from "./ProductCreationTitle.vue?vue&type=template&id=3055c9ee&scoped=true"
import script from "./ProductCreationTitle.vue?vue&type=script&lang=js"
export * from "./ProductCreationTitle.vue?vue&type=script&lang=js"
import style0 from "./ProductCreationTitle.vue?vue&type=style&index=0&id=3055c9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055c9ee",
  null
  
)

export default component.exports